import React from "react";
import * as styles from "./MenuSection.module.scss";
import MenuSectionItem from "./MenuSectionItem";

type MenuSectionSingleProps = {
  label: string;
  url: string | undefined;
  trackingName: string | undefined;
  className?: string;
};
const MenuSectionSingle: React.FC<MenuSectionSingleProps> = ({
  label,
  url,
  trackingName,
  className
}) => {
  return (
    <MenuSectionItem className={className}>
      <a
        href={url}
        className={styles.button}
        role="menuitem"
        data-content-piece={trackingName}
      >
        {label}
      </a>
    </MenuSectionItem>
  );
};

export default MenuSectionSingle;
